import { Component } from '@angular/core';

@Component({
  template: `
    @if (value !== undefined) {
      <div class="value">
        @if (code) {
          {{ value | glxyCurrency: code }}
        } @else {
          {{ value | glxyCurrency }}
        }
      </div>
    } @else {
      <glxy-blank-value />
    }
  `,
  standalone: false,
})
export class CurrencyRendererComponent {
  value: number | undefined;
  code: string | undefined;
}
